import commentsApiService from '@/services/api/Comments'

const emptyModel = {
  comment: null,
  user_id: null,
  commentable_type: null,
  commentable_id: null
}

class Comment {
  constructor() {
    this.api = commentsApiService
    this.emptyModel = emptyModel
  }
}

let comment = new Comment()

export default comment
